// extracted by mini-css-extract-plugin
export var chevron = "_2o-d";
export var disabled = "_2o-b";
export var error = "_2o-c";
export var hideBorder = "_2o-1";
export var icon = "_2o-e";
export var input = "_2o-0";
export var large = "_2o-f";
export var open = "_2o-9";
export var placeholder = "_2o-a";
export var regular = "_2o-5";
export var singleRowInput = "_2o-2";
export var singleSelectInput = "_2o-3 _2o-0";
export var small = "_2o-4";
export var spinnerContainer = "_2o-i";
export var tag = "_2o-7";
export var tagsContainer = "_2o-8";
export var tagsInput = "_2o-6 _2o-0";
export var xSmall = "_2o-g";
export var xxSmall = "_2o-h";